export default __webpack_public_path__ + "static/media/mlrit-mun logo try2.3b945b09.png";